import React from 'react'
import { CartPickUpDetails, CartSummary } from '../Components/Page/Cart'

function ShoppingCart() {
  return (
    <div className="row w-100" style={{ marginTop: "10px" }}>
    <div className="col-lg-6 col-12" style={{ fontWeight: 300 }}>
      <CartSummary />
    </div>
    <div className="col-lg-6 col-12 p-4 d-none d-md-block d-lg-block d-xl-block">
      <CartPickUpDetails/>
    </div>
    <div className="col-lg-6 col-12 p-4 mx-2 d-block d-md-none d-lg-none d-xl-none">
      <CartPickUpDetails/>
    </div>
  </div>
  )
}

export default ShoppingCart